const BASE = '/api';

async function req(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options,
  });
  if (!res.ok) {
    const err = new Error(`HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

const api = {
  requestLink: (email, lang) => req('/auth/request-link', { method: 'POST', body: JSON.stringify({ email, lang }) }),
  me: () => req('/auth/me'),
  logout: () => req('/auth/logout', { method: 'POST' }),
  summary: () => req('/me/summary'),
  terms: () => req('/terms'),
  acceptTerms: () => req('/me/accept-terms', { method: 'POST', body: JSON.stringify({}) }),
};

export default api;
